module.exports = __webpack_public_path__ + "16e59fbe475179a254d4650124cdfbdf.svg";